"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelInfoWrapper = exports.PanelInfoItem = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var PanelInfoItem = function (props) {
    var label = props.label, value = props.value, labelClassName = props.labelClassName, className = props.className;
    return (react_1.default.createElement(exports.PanelInfoWrapper, { className: (0, classnames_1.default)('panel-info-wrapper', className, labelClassName ? 'top-model-section' : 'about') },
        react_1.default.createElement(Label, { className: "man-label" },
            label,
            ":"),
        value));
};
exports.PanelInfoItem = PanelInfoItem;
var Label = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: 4px;\n  color: ", ";\n"], ["\n  margin-right: 4px;\n  color: ", ";\n"])), function (props) { return props.theme.primary7; });
exports.PanelInfoWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 0.9rem;\n\n  &.about.modal-class {\n    color: #000000;\n\n    ", " {\n      color: #adadad;\n    }\n  }\n"], ["\n  font-size: 0.9rem;\n\n  &.about.modal-class {\n    color: #000000;\n\n    ", " {\n      color: #adadad;\n    }\n  }\n"])), Label);
exports.default = exports.PanelInfoItem;
var templateObject_1, templateObject_2;
